<template>
  <el-row :gutter="20">
    <el-col :span="1"></el-col>
    <el-col class="ship-block" :span="10" @click="clickShip(item.item1.shipUrl)">
      <el-row :gutter="20">
        <el-col :span="6">
          <img class="ship-icon" :src="item.item1.shipIcon">
        </el-col>
        <el-col :span="18">
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="ship-name">
                {{ item.item1.shipName }}
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="ship-info">
                {{ item.item1.shipInfo }}
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="2">
    </el-col>
    <!--  注意判断单数  -->
    <el-col v-if="item.item2 !==undefined" class="ship-block" :span="10" @click="clickShip(item.item2.shipUrl)">
      <el-row :gutter="20">
        <el-col :span="6">
          <img class="ship-icon" :src="item.item2.shipIcon">
        </el-col>
        <el-col :span="18">
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="ship-name">
                {{ item.item2.shipName }}
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="ship-info">
                {{ item.item2.shipInfo }}
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="1"></el-col>
  </el-row>
</template>

<script>
export default {
  name: "shipLink",
  props: ['item'],
  data() {
    return {}
  },
  methods: {
    //点击链接
    clickShip(url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>
.ship-block {
  margin-top: 10px;
  padding: 5px;
  background-color: #ffffff;
  border: solid #6b7a8a 2px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.ship-block:hover {
  cursor: pointer;
}

.ship-icon {
  width: 50px;
  height: 50px;
}

.ship-name {
  height: 25px;
  font-size: 16px;
  line-height: 25px;
}

.ship-info {
  font-family: 华文仿宋;
  height: 25px;
  font-size: 14px;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>